import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Group = styled(View, theme => {
  return {
    base: {},
    variants: {},
  }
})

export const Container = styled(View, theme => {
  return {
    base: {
      position: 'absolute',
    },
    variants: {},
  }
})
